export default __webpack_public_path__ + "static/media/organizing.fbe7fbfa.svg";